import React from 'react';

interface DragHandleProps {
  className: string;
}

const DragHandle: React.FC<DragHandleProps> = ({ className }) => (
  <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
    <path d="M2 4H14M2 12H14M2 8H14" stroke="#262641" strokeWidth="1.67" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export default DragHandle;
